import homeCtrl from './controllers/reportcardController';
export default angular.module('ReportCardListsModule', [])
    .controller('reportCardListing', homeCtrl);


// WEBPACK FOOTER //
// ./src/app/report_cards/teacher/reportCardListModule.js